import { cn } from '@/lib/cn'
import { StarIcon } from './icons'

interface RatingProps {
  /** 0 a 5. */
  value: number
  /** Exibe o número à esquerda das estrelas. */
  showValue?: boolean
  count?: number | null
  size?: number
  className?: string
}

export function Rating({ value, showValue, count, size = 14, className }: RatingProps) {
  const rounded = Math.round(value)

  return (
    <div className={cn('flex items-center gap-1.5', className)}>
      {showValue && (
        <span className="text-[13px] text-ink-soft">{value.toFixed(1)}</span>
      )}
      <span
        className="flex items-center gap-0.5 text-star"
        role="img"
        aria-label={`Avaliação ${value.toFixed(1)} de 5`}
      >
        {Array.from({ length: 5 }).map((_, index) => (
          <StarIcon
            key={index}
            filled={index < rounded}
            style={{ width: size, height: size }}
          />
        ))}
      </span>
      {count != null && count > 0 && (
        <span className="text-[13px] text-ink-faint">({count})</span>
      )}
    </div>
  )
}
